import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import * as s from './RankButtonsContainer.scss'

const RankButtonsContainer = ({ ranks = [], game, show = false, onClick, onClose, isOuRanks = false }) => {
    const currentRank = isOuRanks ? game.ouRank : game.rank
    const close = () => onClose({ stopPropagation: () => {} }, false)
    return (
        <Modal show={show} onHide={close} centered size='sm' contentClassName={s.container} aria-labelledby={`points-title-${game.game}-${isOuRanks}`}>
            <Modal.Header closeButton>
                <Modal.Title id={`points-title-${game.game}-${isOuRanks}`}>Assign {isOuRanks ? 'over/under ' : ''}points</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className={s.matchup}>{game.favoriteMascot} vs. {game.underdogMascot}</p>
                <p className={s.hint}>Currently {currentRank} points. Choose a value to move this game in your confidence order.</p>
                <div className={s.rankButtons} role='group' aria-label='Choose confidence points'>
                    {ranks.map(rank => <Button key={rank} aria-label={`${rank} ${rank === 1 ? 'point' : 'points'}${rank === currentRank ? ', current assignment' : ''}`}
                        aria-pressed={rank === currentRank} variant={rank === currentRank ? 'success' : 'outline-success'}
                        onClick={event => rank === currentRank ? close() : onClick(event, rank)}>{rank}</Button>)}
                </div>
            </Modal.Body>
            <Modal.Footer><Button variant='light' onClick={close}>Cancel</Button></Modal.Footer>
        </Modal>
    )
}

export default RankButtonsContainer
